import { intl } from '@beelday/common'
import {
	ACTIVE_TOOL_HINT_KEYS,
	ActiveTool,
	BLOCKED_ACTION_HINT_KEYS,
	BlockedMenuAction,
} from 'room/common/model/active-tool'

type Props = {
	tool: ActiveTool
	action: BlockedMenuAction
}

export const ToolBlockedHint = ({ tool, action }: Props): JSX.Element => {
	const translate = intl.useTranslate()
	return (
		<intl.Translate
			blocker={translate(ACTIVE_TOOL_HINT_KEYS[tool])}
			action={translate(BLOCKED_ACTION_HINT_KEYS[action])}
		>
			room_menu.hint.blocked
		</intl.Translate>
	)
}

export default ToolBlockedHint
